import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { accountVerificationResolver } from '@resolvers/account-verification.resolver';
import { AccountVerificationComponent } from './account-verification/account-verification.component';
import { metaTags } from '@app/meta-tags';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { resetPasswordResolver } from '@resolvers/reset-password.resolver';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'account-verification',
                component: AccountVerificationComponent,
                resolve: {
                    verify: accountVerificationResolver,
                },
                data: {
                    metaTags: metaTags.accountVerification,
                },
            },
            {
                path: 'reset-password',
                component: ResetPasswordComponent,
                resolve: {
                    checkToken: resetPasswordResolver,
                },
                data: {
                    metaTags: metaTags.resetPassword,
                },
            },
            {
                path: '**',
                redirectTo: '/error/not-found',
            },
            { path: '', redirectTo: '/', pathMatch: 'full' },
        ],
    },
    {
        path: '**',
        redirectTo: '/error/not-found',
    },
    { path: '', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
